module.exports = __webpack_public_path__ + "img/black-marker.0b1b8f0e.svg";